module.exports = __webpack_public_path__ + "static/media/bubbles.8c729f6e.png";